import Desktop from './MenuDesktop'
import Mobile from './MenuMobile'

export default {
  Mobile,
  Desktop,
}
